<div class="container" style="padding-top: 140px">
  <app-breadcrumb category="My Account / My Orders"></app-breadcrumb>
  <div style="height: 24px"></div>
  <div class="row">
    <div class="col-lg-3">
      <div class="container-1">
        <h5 style="font-family: 'proxima-nova'; font-size: 24px;">my account</h5>
        <li><a routerLink="/myaccount">Account Information</a></li>
        <br />
        <a> My Orders</a> <br />
        <a (click)="logout()">Logout</a><br /><br />
      </div>
    </div>

    <div class="col-lg-9">
      <h5 style="font-family: 'proxima-nova'; font-size: 24px;">My Orders</h5>

      <br />
      
      <div class="container">
        <app-myorder-item *ngFor="let o of orders" [data]="o"> </app-myorder-item>
      </div>
    </div>
  </div>
</div>
